const useWebEngageMyGiftClick = () => {
  const trackWebEngageMyGiftClick = () => {
    try {
      window.webengage.track("my_gift_click");
    } catch (error) {
      console.log("🚀 ~ myGiftClickWebEngage ~ error:", error);
    }
  };

  return { trackWebEngageMyGiftClick };
};

export default useWebEngageMyGiftClick;
